<div *ngFor="let node of data" [ngClass]="{ 'item-selected': node.selected}" class="tree-item">

    <div class="twc-d-flex tree-item-header" [ngClass]="{ 'tree-item-with-children': hasVisibleChildren(node)}"
        *ngIf="node.visible">
        <div *ngIf="hasVisibleChildren(node) else noIcon" (click)="expandClick(node)">
            <twc-icon *ngIf="!node.collapsed; else notExpanded" shape="acc-up"></twc-icon>
        </div>

        <div class="twc-checkbox twc-mr-2" *ngIf="multiSelection">
            <twc-checkbox>
                <input class="item-checkbox" twcCheckboxInput type="checkbox" [ngModel]="node.checked"
                    [disabled]="isCheckboxDisabled(node)" (ngModelChange)="checkboxChecked(node, $event)"
                    [indeterminate]="false">
                <label twcCheckboxLabel></label>
            </twc-checkbox>
        </div>

        <div class="twc-d-flex align-center text-width"
            [ngClass]="{ 'not-checked': (!node.checked || node.inactive) && multiSelection}">
            <twc-icon *ngIf="node.icon" class="item-icon twc-mr-2" [shape]="node.icon" [size]="iconSize"
                (click)="selectItem(node)">
            </twc-icon>
            <div class="item-label cw-text-overflow-ellipsis" cwEllipsisActive (click)="selectItem(node)">
                <cw-text-highlight *ngIf="node !== treeviewService.nodeEditing" [text]="node.title"
                    [selectedText]="searchText$ | async" (dblclick)="treeviewService.enableEditing(node)">
                </cw-text-highlight>
                <input type="text" cwAutoFocus [autoSelection]="true" *ngIf="node===treeviewService.nodeEditing"
                    class="twc-mr-2" [(ngModel)]="node.title" (blur)="onNameChange(node)"
                    (keydown)="onKeyDown($event, node)" />
            </div>

        </div>
        <div class="item-icon-action" *ngIf="node.actionIconButton">
            <twc-icon [size]="20" shape="{{node.actionIconButton.icon}}"
                twcTooltip="{{node.actionIconButton.iconTooltip | translate}}"
                (click)="node.actionIconButton.actionFn(node.id)"></twc-icon>
        </div>
    </div>

    <div *ngIf="node.children.length && !node.collapsed" class="twc-mb-2" [ngClass]="{'twc-ml-4': node.visible}">
        <cw-treeview-item [data]="node.children" [multiSelection]="multiSelection" [iconSize]="iconSize"
            (selectedItem)="selectItem($event)" (itemCheckedChange)="checkItem($event)"
            [parentUnchecked]="!node.checked" [isReadonly]="isReadonly"></cw-treeview-item>
    </div>
</div>

<ng-template #noIcon>
    <div class="no-icon"></div>
</ng-template>

<ng-template #notExpanded>
    <twc-icon shape="acc-down"></twc-icon>
</ng-template>